export default {"src":"/_next/static/media/trophy.e1f63085.svg","height":128,"width":112,"blurWidth":0,"blurHeight":0};